// ════════════════════════════════════════
// app/courses/seo-course.tsx
// ════════════════════════════════════════
import { CourseCategoryPage } from '@/components/seo/CourseCategoryPage';
export default function SEOCoursePage() {
  return (
    <CourseCategoryPage
      config={{
        title: 'קורס SEO וקידום אתרים',
        metaTitle: 'קורס SEO וקידום אתרים 2025 – Google, תוכן, טכני | Kursi',
        slug: 'seo-course',
        metaDescription: 'קורסי SEO וקידום אתרים 2025 – קידום אורגני בגוגל, כתיבת תוכן, SEO טכני. מדריך לבחירת קורס SEO שמביא תוצאות. קבלו 3 המלצות קורסים אישיות.',
        subtitle: 'קידום אורגני ב-Google, כתיבת תוכן לSEO וטכני — מצאו קורס SEO שיביא תוצאות אמיתיות.',
        chips: ['Google SEO', 'תוכן', 'טכני', 'Local SEO', 'אנליטיקס', 'לינקים'],
        chatSeed: 'קורס SEO קידום אתרים',
        sections: [
          {
            id: 'types',
            title: 'סוגי SEO שצריך לדעת',
            body: 'SEO מתחלק לשלושה: On-Page (תוכן וכותרות), Off-Page (קישורים) ו-Technical (מהירות, קוד). קורס טוב מכסה את שלושתם.',
            bullets: [
              'On-Page: כותרות, מטא, תוכן ממוקד',
              'Off-Page: בניית קישורים (Link Building)',
              'Technical SEO: מהירות, Core Web Vitals, Crawl',
              'Local SEO: Google My Business',
              'E-E-A-T: אמינות ומומחיות לפי גוגל',
            ],
          },
          {
            id: 'tools',
            title: 'כלים שחובה ללמוד',
            body: 'SEO בלי כלים זה עיוור. קורס טוב מלמד לעבוד עם Google Search Console, Ahrefs או Semrush ו-GA4.',
            bullets: [
              'Google Search Console: חובה, חינמי',
              'Google Analytics 4: ניתוח תנועה',
              'Ahrefs / Semrush: מחקר מתחרים וקישורים',
              'Screaming Frog: סריקה טכנית',
              'Google PageSpeed Insights: מהירות',
            ],
          },
          {
            id: 'results',
            title: 'ציפיות ריאליות',
            body: 'SEO לוקח זמן. תוצאות ראשונות לרוב אחרי 3–6 חודשים. מי שמבטיח "עמוד ראשון תוך שבועיים" — לא אמין.',
            bullets: [
              '3–6 חודשים: תוצאות ראשוניות',
              '6–12 חודשים: צמיחה משמעותית',
              'SEO משתלם לטווח ארוך — בלי לשלם לפר-קליק',
              'תוכן איכותי הוא עדיין הבסיס',
            ],
          },
        ],
        checklist: [
          'הקורס מכסה On-Page, Off-Page וטכני',
          'יש עבודה עם כלי SEO אמיתיים',
          'מעודכן לאלגוריתמים של 2024–2025',
          'יש פרויקט מעשי על אתר אמיתי',
          'המרצה עם תוצאות SEO מוכחות',
        ],
        redFlags: [
          'הבטחות "עמוד ראשון ב-30 יום"',
          'לימוד Black Hat SEO (קישורים ספאם)',
          'חומר ישן שלא מכסה Core Web Vitals ו-AI Overviews',
          'אין עבודה עם כלים אמיתיים',
        ],
        faq: [
          { q: 'כמה זמן לוקח ללמוד SEO?', a: 'יסודות: 2–3 חודשים. לרמת עצמאי מקצועי: 6–12 חודשים עם תרגול על אתרים אמיתיים.' },
          { q: 'האם SEO עדיין רלוונטי בעידן AI?', a: 'כן, ואפילו יותר. גוגל עדיין שולטת, ו-AI Overviews דורש תוכן E-E-A-T מעמיק. SEO השתנה אבל לא נעלם.' },
          { q: 'כמה מרוויח מומחה SEO?', a: 'פרילנסר: 3,000–8,000₪ לפרויקט. שכיר: 12,000–22,000₪. יועץ מנוסה: 5,000–15,000₪ לחודש ללקוח.' },
        ],
      }}
    />
  );
}

// ════════════════════════════════════════
// app/courses/photo-video.tsx
// ════════════════════════════════════════
export function PhotoVideoPage() {
  return (
    <CourseCategoryPage
      config={{
        title: 'קורס צילום ועריכת וידאו',
        metaTitle: 'קורס צילום ועריכת וידאו 2025 – Premiere, Lightroom | Kursi',
        subtitle: 'צילום מקצועי, עריכת וידאו, אנימציה ו-After Effects — קורסים לכל רמה ומטרה.',
        chips: ['צילום', 'Premiere Pro', 'Lightroom', 'After Effects', 'אנימציה', 'תוכן לרשתות'],
        chatSeed: 'קורס צילום ועריכת וידאו',
        sections: [
          {
            id: 'specialization',
            title: 'צילום, וידאו, אנימציה — מה מתאים לכם?',
            body: 'תחום הוויז׳ואל רחב מאוד. חשוב לבחור התמחות לפני שמתחילים.',
            bullets: [
              'צילום: פורטרט, מוצרים, חתונות, נוף',
              'עריכת וידאו: Premiere Pro, DaVinci Resolve',
              'After Effects: Motion Graphics, אנימציה',
              'תוכן לרשתות: Reels, TikTok, YouTube',
              'קולנוע: בימוי, סינמטוגרפיה, תסריטאות',
            ],
          },
          {
            id: 'gear',
            title: 'ציוד — כמה צריך להשקיע?',
            body: 'הטעות הנפוצה: לקנות ציוד יקר לפני שיש ידע. קורס טוב מלמד לעשות הרבה עם מעט ציוד.',
            bullets: [
              'מצלמה בינונית + עדשה אחת טובה — מספיק להתחיל',
              'סמארטפון + ידע = תוצאות מעולות לרשתות',
              'תאורה: משפיעה יותר מהמצלמה',
              'עריכה: מחשב עם RAM טוב + תוכנה',
            ],
          },
          {
            id: 'portfolio',
            title: 'פורטפוליו שמוכר',
            body: 'בתחום הוויז׳ואל הכול מתחיל ומסתיים בפורטפוליו. אינסטגרם, Behance, אתר אישי — אלה כרטיסי הביקור שלכם.',
            bullets: [
              'אינסטגרם מסודר וממותג',
              'Behance לעיצוב ואנימציה',
              'אתר אישי עם גלריה',
              '10 עבודות מצוינות עדיפות על 50 בינוניות',
            ],
          },
        ],
        checklist: [
          'הקורס כולל עבודה עם תוכנות אמיתיות',
          'יש פרויקטים לפורטפוליו',
          'המרצה עם פורטפוליו מקצועי',
          'יש ביקורת עבודות אישית',
          'הקורס מכסה את הצד העסקי (תמחור, לקוחות)',
        ],
        redFlags: [
          'קורס שמתמקד בציוד ולא בידע',
          'אין פרויקטים לפורטפוליו',
          'תוכנות ישנות (Premiere CS6)',
          'ללא ביקורת עבודות',
        ],
        faq: [
          { q: 'האם צריך מצלמה יקרה לצילום מקצועי?', a: 'לא. ידע > ציוד. Canon R50 או Sony A6400 מספיקות להתחלה. עדשה טובה חשובה יותר מגוף המצלמה.' },
          { q: 'כמה מרוויח צלם מקצועי?', a: 'צלם חתונות: 3,000–10,000₪ לאירוע. צלם מוצרים: 800–3,000₪ ליום. עורך וידאו פרילנסר: 150–400₪ לשעה.' },
          { q: 'מה עדיף — Premiere Pro או DaVinci?', a: 'Premiere: נפוץ יותר, Adobe Creative Cloud. DaVinci: חינמי, כלי גרדינג מעולים. שניהם מקובלים בתעשייה.' },
        ],
      }}
    />
  );
}

// ════════════════════════════════════════
// app/courses/finance-advice.tsx
// ════════════════════════════════════════
export function FinanceAdvicePage() {
  return (
    <CourseCategoryPage
      config={{
        title: 'קורס ייעוץ כלכלי וליווי פיננסי',
        metaTitle: 'קורס ייעוץ כלכלי 2025 – פיננסים, ליווי עסקי | Kursi',
        subtitle: 'ייעוץ כלכלי, ליווי פיננסי אישי ועסקי, ניתוח דוחות — קורסים למי שרוצה לעזור לאחרים לנהל כסף.',
        chips: ['ייעוץ כלכלי', 'פיננסים אישיים', 'ניתוח דוחות', 'ליווי עסקי', 'תכנון פרישה'],
        chatSeed: 'קורס ייעוץ כלכלי',
        sections: [
          {
            id: 'types',
            title: 'ייעוץ כלכלי — מה כולל?',
            body: 'ייעוץ כלכלי הוא מושג רחב. יש ייעוץ פיננסי אישי, ייעוץ להשקעות, ליווי עסקי וניתוח דוחות. כל תחום דורש הכשרה שונה.',
            bullets: [
              'ייעוץ פיננסי אישי: תקציב, חיסכון, ביטוחים',
              'ייעוץ להשקעות: שוק ההון, פנסיה, נדל"ן',
              'ליווי עסקי: תזרים, תמחור, גיוס אשראי',
              'ניתוח דוחות כספיים: לכלכלנים ומנהלים',
              'תכנון פרישה: חסכונות, קצבאות, פנסיה',
            ],
          },
          {
            id: 'regulation',
            title: 'רגולציה — מה מותר ומה לא',
            body: 'ייעוץ השקעות בישראל דורש רישיון מרשות ניירות ערך. ייעוץ פיננסי כללי — לא דורש. חשוב לדעת את הגבולות.',
            bullets: [
              'יועץ השקעות: דורש רישיון רשות ני"ע',
              'יועץ פיננסי: לא דורש רישיון (אבל מומלץ)',
              'מתכנן פרישה: הסמכות מוכרות (CFP)',
              'כל עצה רפואית/משפטית — מחוץ לגבול',
            ],
          },
          {
            id: 'practical',
            title: 'כיצד בונים עסק ייעוץ כלכלי?',
            body: 'רוב יועצי הכלכלה עובדים עצמאית. קורס טוב מלמד לא רק תוכן אלא גם איך לבנות תיק לקוחות ולתמחר שירותים.',
            bullets: [
              'תמחור שירותי ייעוץ',
              'בניית אמון עם לקוחות',
              'שיווק דיגיטלי לייעוץ',
              'ניהול ישיבות ייעוץ יעילות',
            ],
          },
        ],
        checklist: [
          'הקורס מסביר גבולות רגולטוריים',
          'יש תרגול עם מקרים אמיתיים',
          'המרצה עם ניסיון מקצועי מוכח',
          'יש הסמכה מוכרת בסוף',
          'מכסה גם את הצד העסקי',
        ],
        redFlags: [
          'לא מסביר גבולות רגולטוריים',
          'הבטחות "תרוויח X₪ מלקוח ראשון"',
          'מרצה ללא ניסיון ייעוץ אמיתי',
          'אין הבחנה בין ייעוץ לשיווק מוצרי פיננסיים',
        ],
        faq: [
          { q: 'האם צריך רישיון לייעוץ כלכלי?', a: 'ייעוץ השקעות — כן, רישיון רשות ני"ע. ייעוץ פיננסי כללי (תקציב, חיסכון) — לא חובה אבל הסמכה מגבירה אמינות.' },
          { q: 'כמה מרוויח יועץ כלכלי?', a: 'ייעוץ שעתי: 300–700₪. תכנית ייעוץ מלאה: 3,000–12,000₪. עם 10–15 לקוחות פעילים: 15,000–35,000₪.' },
        ],
      }}
    />
  );
}

// ════════════════════════════════════════
// app/courses/sales.tsx
// ════════════════════════════════════════
export function SalesPage() {
  return (
    <CourseCategoryPage
      config={{
        title: 'קורס מכירות ושירות לקוחות',
        metaTitle: 'קורס מכירות 2025 – טלמרקטינג, B2B, שירות לקוחות | Kursi',
        subtitle: 'מכירות, ניהול מכירות ושירות לקוחות — קורסים שיהפכו אתכם לאנשי מכירות מצוינים.',
        chips: ['B2B', 'B2C', 'טלמרקטינג', 'שירות לקוחות', 'ניהול מכירות', 'SPIN'],
        chatSeed: 'קורס מכירות',
        sections: [
          {
            id: 'types',
            title: 'איזה סוג מכירות?',
            body: 'מכירות B2B (עסק לעסק), B2C (לצרכן), מכירות הייטק, טלמרקטינג — כל אחד דורש כישורים שונים.',
            bullets: [
              'B2B: מכירות לעסקים, תהליך ארוך',
              'B2C: מכירות לצרכן, תהליך קצר',
              'Tech Sales: מכירות תוכנה ופתרונות',
              'Inbound: לקוחות נכנסים',
              'Outbound: יצירת לידים פעילה',
            ],
          },
          {
            id: 'skills',
            title: 'מה לומדים בקורס מכירות?',
            body: 'קורס מכירות טוב לא רק מלמד "טכניקות סגירה". הוא מלמד להבין צרכי לקוח, להתמודד עם התנגדויות ולבנות אמון.',
            bullets: [
              'מתודולוגיות: SPIN, Challenger, Solution Selling',
              'ניהול pipeline ו-CRM',
              'התמודדות עם התנגדויות',
              'תסריטי שיחה ומשא ומתן',
              'שירות לקוחות ו-Customer Success',
            ],
          },
          {
            id: 'career',
            title: 'קריירה במכירות',
            body: 'מכירות הייטק זו מהקריירות הכי משתלמות בישראל. SDR מתחיל: 12,000–15,000₪. Account Executive מנוסה: 25,000–50,000₪ עם עמלות.',
            bullets: [
              'SDR: ייצור לידים, תפקיד כניסה',
              'Account Executive: סגירת עסקאות',
              'Sales Manager: ניהול צוות',
              'Customer Success: שימור לקוחות',
            ],
          },
        ],
        checklist: [
          'הקורס כולל Role Play ותרגול שיחות',
          'מכסה CRM (Salesforce, HubSpot)',
          'יש תרגול התמודדות עם התנגדויות',
          'המרצה עם ניסיון שטח במכירות',
          'יש ליווי בחיפוש עבודה',
        ],
        redFlags: [
          'קורס שמלמד רק "טריקים לסגירה"',
          'אין Role Play ותרגול שיחות',
          'מרצה ללא ניסיון מכירות אמיתי',
          'לא מכסה CRM ותהליכי עבודה',
        ],
        faq: [
          { q: 'האם צריך ניסיון קודם למכירות?', a: 'לא. מכירות הוא אחד התחומים הנגישים ביותר לכניסה ללא ניסיון. העיקר: תקשורת טובה ורצון ללמוד.' },
          { q: 'כמה מרוויח איש מכירות בהייטק?', a: 'SDR: 12,000–18,000₪. AE מנוסה: 25,000–60,000₪ עם עמלות. Sales Manager: 30,000–70,000₪.' },
        ],
      }}
    />
  );
}

// ════════════════════════════════════════
// app/courses/management.tsx
// ════════════════════════════════════════
export function ManagementPage() {
  return (
    <CourseCategoryPage
      config={{
        title: 'קורס ניהול ומנהיגות',
        metaTitle: 'קורס ניהול ומנהיגות 2025 – מנהלים, פיתוח ארגוני | Kursi',
        subtitle: 'ניהול צוותים, מנהיגות, פיתוח ארגוני וניהול פרויקטים — קורסים למנהלים בכל רמה.',
        chips: ['ניהול צוות', 'מנהיגות', 'פרויקטים', 'Agile', 'OKR', 'פיתוח ארגוני'],
        chatSeed: 'קורס ניהול ומנהיגות',
        sections: [
          {
            id: 'types',
            title: 'איזה קורס ניהול מתאים לכם?',
            body: 'ניהול כולל מגוון רחב: ניהול צוותים, ניהול פרויקטים, ניהול בכיר ופיתוח ארגוני. כל תפקיד דורש דגשים שונים.',
            bullets: [
              'ניהול צוות: תקשורת, משוב, מוטיבציה',
              'ניהול פרויקטים: PMP, Agile, Scrum',
              'ניהול בכיר: אסטרטגיה, דירקטוריון',
              'פיתוח ארגוני: תרבות, תהליכים, שינוי',
              'מנהיגות: קואצ׳ינג, חזון, השפעה',
            ],
          },
          {
            id: 'skills',
            title: 'מה מבדיל מנהל טוב?',
            body: 'מנהל טוב לא נולד כזה — הוא מתפתח. קורסי ניהול טובים מלמדים לא רק כלים אלא גם חשיבה ניהולית ויכולת קבלת החלטות.',
            bullets: [
              'תקשורת ברורה וישירה',
              'מתן משוב אפקטיבי',
              'קבלת החלטות בתנאי אי-ודאות',
              'ניהול קונפליקטים',
              'בניית תרבות צוות',
            ],
          },
          {
            id: 'certs',
            title: 'הסמכות ניהוליות מוכרות',
            body: 'PMP, Agile/Scrum ו-MBA — הסמכות שמעסיקים מחפשים. לא חובה אבל מוסיפות ערך משמעותי לקורות החיים.',
            bullets: [
              'PMP (Project Management Professional)',
              'Scrum Master (CSM)',
              'Agile Certified (PMI-ACP)',
              'OKR Certification',
            ],
          },
        ],
        checklist: [
          'הקורס מכסה גם כלים וגם מיומנויות בין-אישיות',
          'יש תרגול עם מקרים ניהוליים אמיתיים',
          'המרצה עם ניסיון ניהולי אמיתי',
          'יש הסמכה מוכרת (PMP, Scrum) אם רלוונטי',
          'יש קבוצת עמיתים לתרגול',
        ],
        redFlags: [
          'קורס תיאורטי בלבד ללא תרגול',
          'מרצה ללא ניסיון ניהולי',
          'מתמקד רק ב"כלים" ללא מיומנויות אנושיות',
          'אין תרגול Role Play של שיחות קשות',
        ],
        faq: [
          { q: 'האם אפשר ללמוד ניהול ללא ניסיון?', a: 'כן, אבל עדיף לשלב עם ניסיון. הידע מהקורס מתחיל לעבוד כשיש הזדמנות לתרגל בפועל.' },
          { q: 'האם MBA שווה את ההשקעה?', a: 'תלוי במטרה. לניהול בכיר — כן. לניהול צוות — לא חובה. PMP ו-Agile לרוב מספיקים.' },
        ],
      }}
    />
  );
}